/**
 * HostPoint POS - Idle Timeout Warning Dialog
 * Shows warning before auto-logout with countdown
 */

import { Clock, LogOut, MousePointerClick } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

export function IdleWarningDialog({ open, remainingTime, onExtend, onLogout }) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-sm">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-yellow-600">
            <Clock className="h-5 w-5" />
            Session Expiring
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              You will be logged out due to inactivity in{' '}
              <span className="font-bold text-xl text-foreground">
                {remainingTime}
              </span>{' '}
              seconds.
            </p>
            <p className="text-sm">
              Click anywhere or press any key to stay logged in.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        {/* Countdown visual */}
        <div className="flex justify-center py-4">
          <div className="relative w-20 h-20">
            <svg className="w-20 h-20 transform -rotate-90">
              <circle
                cx="40"
                cy="40"
                r="36"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
                className="text-muted"
              />
              <circle
                cx="40"
                cy="40"
                r="36"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
                strokeDasharray={`${(remainingTime / 30) * 226} 226`}
                className="text-yellow-500 transition-all duration-1000"
              />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-2xl font-bold">{remainingTime}</span>
            </div>
          </div>
        </div>

        <AlertDialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onLogout}>
            <LogOut className="h-4 w-4 mr-2" />
            Logout Now
          </Button>
          <Button onClick={onExtend} className="bg-primary">
            <MousePointerClick className="h-4 w-4 mr-2" />
            Stay Logged In
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default IdleWarningDialog;
